import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InactiveService {
  private readonly inactivityTimeout = 900000; // 15 minutes
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private inactivityTimer: any;
  private readonly inactivitySubject = new Subject<void>();

  startTimer(): void {
    this.stopTimer();
    this.inactivityTimer = setTimeout(() => {
      this.inactivitySubject.next();
    }, this.inactivityTimeout);
  }

  stopTimer(): void {
    clearTimeout(this.inactivityTimer);
  }

  onInactivity(): Observable<void> {
    return this.inactivitySubject.asObservable();
  }
}
